import { useState } from "react";
import { CONTRACT_NAME, currentApiList, mainnetApiList, v2DAOContract } from "../../data/config";
import axios from 'axios';

export const useCheckAvailability = () => {
    
    const [isAvailable, setIsAvailable] = useState(true);
    const [checkIsLoading, setCheckIsLoading] = useState(false);
    const [lastNameChecked, setLastNameChecked] = useState("");

    const getAvailability = async (name) => {
        setCheckIsLoading(true);
        setIsAvailable(true);
        for (const api of currentApiList) {
            try {
                const res = await axios.post(`${api}/v1/chain/get_account`,{
                    account_name: name,
                    json: true,
                });
                
                if (res.data.account_name) {
                    setIsAvailable(false);
                    console.log(res.data);
                    break;
                }
            } catch (error) {
                console.log(error);
                if(error.message == "Request failed with status code 500"){                    
                    setIsAvailable(true);
                    break;
                }
            }
        }
        setCheckIsLoading(false);
        setLastNameChecked(name);
    }

    return [isAvailable, getAvailability, checkIsLoading, lastNameChecked]
}
